import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';

import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from '@toast-ui/react-editor';

import { db } from '../../utils/firebase-config';
import { PostTitle } from '../../components/styled-components';
import { Header, HeaderLink, Loader, Container } from '../../components';

export const BlogDetailContainer = ({ postDetail, getPostDetail }) => {
    const { uuid = '' } = useParams();
    const [isloading, setIsloading] = useState(false);

    const getData = async () => {
        if (uuid && Object.keys(postDetail).length === 0) {
            setIsloading(true);
            const querySnapshot = await getDoc(doc(db, 'blog-data', String(uuid)));
            getPostDetail(querySnapshot.data());
            setIsloading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <Header actions={<HeaderLink to={'/'}>HOME</HeaderLink>}/>
            <Container>
                {isloading ? <Loader /> : (
                    <div className='post-description-container'>
                        <PostTitle>{postDetail?.title}</PostTitle>
                        <Viewer initialValue={postDetail?.description} />
                    </div>
                )}
            </Container>
        </>
    );
};
